// extracted by mini-css-extract-plugin
module.exports = {"list":"accessRights_list__3fVvI"};